import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) return navigate("/login", { replace: true });
    api.post("/auth/session", { session_id: sessionId, referral_code: localStorage.getItem("parlaylab_ref") || undefined })
      .then(({ data }) => {
        localStorage.removeItem("parlaylab_ref");
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => setError("Google sign-in failed. Please try again."));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex h-screen items-center justify-center text-slate-400" data-testid="auth-callback">
      {error ? <span data-testid="auth-callback-error" className="text-red-400">{error}</span> : <><span className="h-2.5 w-2.5 rounded-full bg-emerald-400 pulse-dot mr-3" /> Signing you in…</>}
    </div>
  );
}
